import { render, staticRenderFns } from "./BaseBSpinner.vue?vue&type=template&id=422bedb4&scoped=true"
import script from "./BaseBSpinner.vue?vue&type=script&lang=js"
export * from "./BaseBSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422bedb4",
  null
  
)

export default component.exports